import React, { useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';

export default function ConfirmCode() {
  const { code } = useParams();

  useEffect(() => {
    if (code) {
      localStorage.setItem('confirmationCode', code);
    }
  }, [code]);

  return <Redirect to={{ pathname: '/' }} />;
}
